<h2 class="left-box">{{ 'common.labels.users' | transloco }}</h2>

@if (this.userGroup) {
<mat-card>
  <mat-card-content>
    <div class="content">
      <app-users-filter [userGroup]="this.userGroup"></app-users-filter>
      <span class="spacer"></span>
      <button (click)="navigateToAddUser()" mat-fab [matTooltip]="'management.addUser' | transloco"
        [attr.aria-label]="'management.buttonThatNavigatesToAddNew' | transloco" color="accent">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    
    @if (!(this.repo.loading$ | async)) {
      <table mat-table matSort [dataSource]="this.repo.resource$"
        (matSortChange)="sort($event)">
        <!-- Username Column -->
        <ng-container matColumnDef="userName">
          <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.username' | transloco }} </th>
          <td mat-cell *matCellDef="let user"> {{user?.userName}} </td>
        </ng-container>
        <!-- First Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.name' | transloco }} </th>
          <td mat-cell *matCellDef="let user"> {{user?.lastName}}, {{user?.firstName}} {{user?.middleName}} </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.email' | transloco }} </th>
          <td mat-cell *matCellDef="let user"> {{user?.contactDetails?.email}} </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.type' | transloco }} </th>
          <td mat-cell *matCellDef="let user"> {{ user?.userType.id | enumLabel:'userType':user?.userType.name }} </td>
        </ng-container>
        <ng-container matColumnDef="configuration">
          <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.configuration' | transloco }} </th>
          <td mat-cell *matCellDef="let user"> {{ user?.configurationDetails?.name ?? userGroup.configurationDetails.name }} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [routerLink]="['./users/', row.id]">
        </tr>
      </table>
    }

    @if (repo.loading$ | async) {
      <div>
        <mat-spinner class="center"></mat-spinner>
      </div>
    }
    @if ((this.repo.resourceCount$ | async) ?? 0 > 0) {
      <mat-paginator [pageSize]="this.repo.pageSize$ | async"
        [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
      [pageSizeOptions]="[10, 25, 50, 100]" (page)="page($event)"></mat-paginator>
    }
  </mat-card-content>
</mat-card>
}